<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Generate Enquiry Form QR Code">
      <v-card-actions> </v-card-actions>
      <v-card-component flat class="px-2">
        <v-row>
          <v-col cols="12" md="4">
            <div>
              <span class="body-2 font-weight-medium">Select Franchisee</span>
              <span class="error--text ml-1">*</span>
              <v-autocomplete
                name="selectFranchisee"
                required
                v-model="franchiseeId"
                key="id"
                class="my-0 py-1"
                single-line
                placeholder="---Select---"
                :items="franchiseeArr"
                item-text="companyName"
                item-value="id"
                @change="qrCodeUrl = ''"
              >
              </v-autocomplete>
              <span class="body-2 font-weight-medium">Size (In Pixel)</span>
              <span class="error--text ml-1">*</span>
              <v-autocomplete
                name="selectSize"
                required
                v-model="qrCodeWidth"
                key="id"
                class="my-0 py-1"
                single-line
                placeholder="---Select Size---"
                :items="sizeOptions"
                item-text="value"
                item-value="id"
                @change="generateQRcode('color')"
              >
              </v-autocomplete>

              <!-- <v-text-field type="number" @input="generateQRcode('color')" v-model="qrCodeWidth" label="Size (In Pixel)"></v-text-field> -->
              <v-color-picker
                @input="generateQRcode('color')"
                v-model="qrCodeColor"
                dot-size="10"
                :hide-canvas="true"
                :hide-inputs="true"
                hide-mode-switch
                :hide-sliders="true"
                mode="hexa"
                show-swatches
                swatches-max-height="100"
              ></v-color-picker>
            </div>
            <v-btn class="mt-5" @click="generateQRcode()" color="accent">
              <v-icon>mdi-qrcode</v-icon>
              Generate QR
            </v-btn>
            <v-btn v-if="qrCodeUrl !== ''" class="mt-5 ms-3" @click="downloadQRcode()" color="success">
              <v-icon>mdi-arrow-down</v-icon>
              Download QR
            </v-btn>
          </v-col>
          <v-col>
            <div v-bind:class="qrCodeUrl !== '' ? 'img-holder' : ''">
              <!-- <small v-if="qrCodeUrl !== ''" class="note">Note: Please hover on the QR code to find download option.</small> -->
              <img class="image" v-if="qrCodeUrl !== ''" :src="qrCodeUrl" alt="QR Code" />
              <div class="middle">
                <!-- <div class="text" @click="downloadQRcode()"><v-icon color="white">mdi-arrow-down</v-icon> DOWNLOAD</div> -->
              </div>
              <a hidden id="download"></a>
            </div>
          </v-col>
        </v-row>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import QRCode from 'qrcode'
// import helper from '@/utils/helper'

export default {
  name: 'QrcodeGenerator',
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      isLoading: false,
      franchiseeId: '',
      franchiseeArr: [],
      qrCodeUrl: '',
      qrCodeColor: '#000000',
      qrCodeWidth: 450,
      sizeOptions: [
        {
          id: 150,
          value: '150 px'
        },
        {
          id: 250,
          value: '250 px'
        },
        {
          id: 350,
          value: '350 px'
        },
        {
          id: 450,
          value: '450 px'
        },
        {
          id: 500,
          value: '500 px'
        }
      ]
    }
  },
  async created () {
    this.franchiseeOptionsGet()
  },
  methods: {
    generateQRcode: async function (type = '') {
      try {
        let opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 1,
          margin: 3,
          color: {
            dark: this.qrCodeColor,
            light: '#FFF'
          },
          width: this.qrCodeWidth
        }
        if (this.franchiseeId) {
          let QRCodeString = `${location.origin}/parent-enquiry/newentry/${Buffer.from(this.franchiseeId.toString()).toString('base64')}`
          this.qrCodeUrl = await QRCode.toDataURL(QRCodeString, opts)
        } else {
          if (type === '') {
            this.$buefy.toast.open({
              message: 'Please select franchisee!',
              type: 'is-danger',
              duration: 4000
            })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    downloadQRcode: function () {
      const url = this.qrCodeUrl
      const a = document.getElementById('download')
      a.style.display = 'none'
      a.href = url
      // the filename you want
      a.download = 'QRcode'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
    },
    franchiseeOptionsGet: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`, {
          params: {
            excludeTesting: 1
          }
        })
        this.franchiseeArr = data.rows
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>
.img-holder {
  position: relative;
  width: fit-content;
}

.text {
  background-color: #04aa6d;
  color: white;
  font-size: 16px;
  padding: 16px 32px;
  cursor: pointer;
  border-radius: 10px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image {
  opacity: 1;
  display: block;
  width: auto;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}
/* .img-holder:hover .image {
  opacity: 0.3;
}

.img-holder:hover .middle {
  opacity: 1;
} */

.note {
  color: red;
  font-weight: 400;
  font-size: 14px;
}
</style>
